export const LOADER_STATUS = "boilerplate/IMS_RECO/LOADER_STATUS";
export const PROFILE_DATA = "boilerplate/IMS_RECO/PROFILE_DATA";
export const SET_ENTITY_LIST = "boilerplate/IMS_RECO/SET_ENTITY_LIST";
export const DEFAULT_ENTITY = "boilerplate/IMS_RECO/DEFAULT_ENTITY";
export const STORE_GSTIN_IMS_RECO = "boilerplate/IMS_RECO/STORE_GSTIN_IMS_RECO";
export const STORE_PERIOD_SINGLE = "boilerplate/IMS_RECO/STORE_PERIOD_SINGLE";
export const STORE_PERIOD = "boilerplate/IMS_RECO/STORE_PERIOD";

export const COMMON_MSG = {
  DATA_DOWNLOADED: "Data downloaded successfully",
};
